module.exports = "<section class=\"final-action\">\n  <div class=\"container\">\n    <p>Ready to build something good?</p>\n    <a routerLink=\"/contact\">Let's talk</a>\n  </div>\n</section>\n\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/parts/final-action/final-action.component.html
// module id = ../../../../../src/app/parts/final-action/final-action.component.html
// module chunks = main